import React, { Fragment } from 'react';
import avatar from 'assets/avatar.png';
import logo from 'assets/logo.svg';
import { NanoTitle } from 'components/Global/Styled';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchUser, refreshUser } from 'components/Membership/redux/actions';
import Hamburger from './components/Hamburger';
import {
  Wrapper,
  SidebarLogoWrapper,
  SidebarButton,
  SidebarButtonImage,
  SidebarButtonsWrapper,
  NavigationWrapper,
  NotificationDot,
} from './components/Styled';
import { links } from './constants';
import Avatar from './components/Avatar';

const CHAT_ROUTE = '/chat';
// The badges are read from /users/self. The sidebar stays mounted across member pages, so they're refreshed
// every minute while the tab is visible, when it becomes visible, and on entering or leaving the chat (#62).
const REFRESH_EVERY_MS = 60 * 1000;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sideMenu: false,
    };

    this.sideMenu = this.sideMenu.bind(this);
  }

  componentDidMount() {
    const { userRequest } = this.props;
    userRequest();

    window.addEventListener('resize', this.handleWindowSizeChange);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.refreshTimer = setInterval(this.refreshWhenVisible, REFRESH_EVERY_MS);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const wasInChat = prevProps.location.pathname === CHAT_ROUTE;
    const isInChat = location.pathname === CHAT_ROUTE;
    if (wasInChat !== isInChat) this.props.userRefresh();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    clearInterval(this.refreshTimer);
  }

  refreshWhenVisible = () => {
    if (document.visibilityState === 'visible') this.props.userRefresh();
  };

  handleVisibilityChange = () => this.refreshWhenVisible();

  // The member is reading the chat, so its count doesn't show there.
  badgeCount = (link) => {
    const { currentUser, location } = this.props;
    if (link.route === CHAT_ROUTE && location.pathname === CHAT_ROUTE) return 0;
    return currentUser[link.notificationKey];
  };

  handleWindowSizeChange = () => {
    if (window.innerWidth > 767) {
      this.setState({ sideMenu: false });
    }
  };

  sideMenu = e => {
    e.preventDefault();
    const { sideMenu } = this.state;
    this.setState({ sideMenu: !sideMenu });
  };

  hideMenu = () => {
    this.setState({ sideMenu: false });
  };

  render() {
    const { currentUser, location } = this.props;
    const { sideMenu } = this.state;

    return (
      <Fragment>
        <Wrapper>
          <NavigationWrapper isActive={sideMenu}>
            <SidebarButtonsWrapper>
              <Link to="/">
                <SidebarLogoWrapper image={logo} />
              </Link>
              {currentUser && (
                <Avatar
                  image={currentUser.image_url || avatar}
                  name={currentUser.name}
                  route={location.pathname}
                  onClick={this.hideMenu}
                />
              )}
              {links.map(link => (
                <SidebarButton to={link.route} route={location.pathname} onClick={this.hideMenu} key={link.route}>
                  {link.notificationKey && (
                    <NotificationDot count={this.badgeCount(link)}>{this.badgeCount(link)}</NotificationDot>
                  )}
                  <SidebarButtonImage src={link.image} alt="" />
                  <NanoTitle>{link.name}</NanoTitle>
                </SidebarButton>
              ))}
            </SidebarButtonsWrapper>
          </NavigationWrapper>
        </Wrapper>

        <Hamburger isActive={sideMenu} click={this.sideMenu} />
      </Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    userRequest: () => dispatch(fetchUser()),
    userRefresh: () => dispatch(refreshUser()),
  };
}

function mapStateToProps(state) {
  return {
    currentUser: state.getIn(['membershipReducer', 'currentUser']),
  };
}

Sidebar.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  userRequest: PropTypes.func,
  userRefresh: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar);
